import React, { ReactNode } from "react";
import { Home, Inbox, MailPlus, Menu, ScrollText, Send } from "lucide-react";
import { Link } from "react-router-dom";
import { UserMenu } from "@/components/UserMenu.tsx";

export interface SidebarShellProps {
  children: ReactNode;
}

export function SidebarShell({ children }: SidebarShellProps) {
  return (
    <div className="drawer lg:drawer-open">
      <input id="sidebar-toggle" type="checkbox" className="drawer-toggle" />
      <div className="drawer-content flex flex-col h-screen">
        <header className="bg-base-100 sticky lg:hidden top-0 z-10 shadow-sm px-4 py-2 flex items-center">
          <label
            htmlFor="sidebar-toggle"
            className="btn btn-square btn-ghost text-slate-700"
          >
            <Menu />
          </label>
          <h1 className="text-xl font-bold">FIT-Connect Muster Onlinedienst</h1>
        </header>

        <main className="p-6 flex-1 overflow-auto bg-base-200">{children}</main>
      </div>

      <div className="drawer-side shadow-sm">
        <label htmlFor="sidebar-toggle" className="drawer-overlay"></label>

        <aside className="w-64 p-5 space-y-4 h-full bg-base-100">
          <nav className="menu font-bold h-full">
            <Link to="/" className="flex justify-center mb-3" aria-label="Logo">
              <img
                src="/fit-connect-logo.svg"
                alt="FIT-Connect"
                className="hidden w-full lg:inline-block align-top"
              />
            </Link>
            <div className="hidden lg:block mb-12 text-gray-600 text-center text-xl">
              Muster Onlinedienst
            </div>
            <ul className="space-y-3 grow">
              <li>
                <Link to="/" className="flex items-center gap-x-2">
                  <Home className="w-6" />
                  Zuhause
                </Link>
              </li>
              <li>
                <Link
                  to="/generic-sender"
                  className="flex items-center gap-x-2"
                >
                  <Send className="w-6" />
                  Generischer Sender
                </Link>
              </li>
              <li>
                <Link to="/event-log" className="flex items-center gap-x-2">
                  <ScrollText className="w-6" />
                  Eventlog
                </Link>
              </li>
              <li>
                <Link
                  to="/search-destinations"
                  className="flex items-center gap-x-2"
                >
                  <Inbox className="w-6" />
                  Zustellpunkt finden
                </Link>
              </li>
              <li>
                <Link to="/replies" className="flex items-center gap-x-2">
                  <MailPlus className="w-6" />
                  Antworten einsehen
                </Link>
              </li>
            </ul>
            <UserMenu />
          </nav>
        </aside>
      </div>
    </div>
  );
}
